import { LeftOutlined } from '@ant-design/icons';
import { Button, ButtonProps } from 'antd';
import * as React from 'react';

interface GoBackButtonState { }

interface GoBackButtonProps extends ButtonProps {
  submitting?: boolean;
}

class GoBackButton extends React.Component<GoBackButtonProps, GoBackButtonState> {
  constructor(props: GoBackButtonProps) {
    super(props);

    this.state = {};
  }

  render() {
    const htmlType = this.props.htmlType ? this.props.htmlType : 'button'
    const buttonType = this.props.type ? this.props.type : 'default'

    return (
      <Button
        {...this.props}
        htmlType={htmlType}
        type={buttonType}
        icon={<LeftOutlined />}
        loading={this.props.submitting || this.props.loading} >
        Go Back
      </Button>
    );
  }
}

export default GoBackButton;
